import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./carousel.css";

import davidSmith from "../../images/david.webp";
import paulWagner from "../../images/paul.webp";
import markLFox from "../../images/mark.webp";
import randyBoldyga from "../../images/randy-boldyga.svg";
import guySimani from "../../images/guy-simani.svg";
import chuckEast from "../../images/chuck-east.svg";
import JimTormey from "../../images/jim-tormey.webp";

import { Container } from "react-bootstrap";

const testimonials = [
    {
        imgSrc: davidSmith,
        name: "David Smith, CEO Tynax, Inc",
        text: "I have been very impressed by ACube's work and would highly recommend them. They quickly perform the work, solve all technical issues in the process, deliver finished results and then check back to ensure that all is working OK. They are a pleasure to work with and I plan to use ACube for several projects in the future.",
    },
    {
        imgSrc: paulWagner,
        name: "Paul Wagner, CEO CreativeLab",
        text: "ACube Technologies is a sharp, dedicated group of guys who will do whatever it takes to complete a job and fulfill a commitment. They ask the right questions, communicate throughout the process and they deliver high-quality work on time and on budget. I recommend ACube for your next project. Hire them, they're great to work with.",
    },
    {
        imgSrc: markLFox,
        name: "Mark L Fox, Vice President SAAF",
        text: "I have been working with Acube Technologies for 2 years now. My plan was for them to help me with a few tasks, but today they simply are my entire IT staff. They are technically capable and are extremely fair as far as costs. I work with them 7 days a week and my business would not exist without them....they have helped me grow my business 300%.",
    },
    {
        imgSrc: randyBoldyga,
        name: "Randy Boldyga, CEO/President RxNT",
        text: "Acube provided excellent service and demonstrated strong technical capability. I would recommend.",
    },
    {
        imgSrc: guySimani,
        name: "Guy Simani, President, Emerald Capital Management",
        text: "The ACube team are reliable, responsive and diligent.",
    },
    {
        imgSrc: chuckEast,
        name: "Chuck East, Technical Product Manager, Openn North America",
        text: "I wanted to email you my sentiments expressed at the end of our side so you can share my appreciation with your teams. Thank you for everyone’s willingness to pull together around the shifting priorities coming into engineering. The hard work, extra hours, and deep product knowledge are examples of how the teams go the extra mile. I have been managing offshore teams for many years, and the Openn engineering team is by far the brightest and most dedicated. Thank you for your continued efforts.",
    },
    {
        imgSrc: JimTormey,
        name: "Jim Tormey, Chief Executive Officer, Sentry Road Training and Development",
        text: "My name is Jim, and I run a learning management software business on Moodle. A few months ago, we needed a part-time developer for projects like platform upgrades and automated reports. The Acube Technologies team has been phenomenal—responsive, communicative, and reliable. They followed through on every commitment and kept me informed of any challenges. I’m a big fan and look forward to working with them in the future.",
    },
];

const TestimonialCarousel = () => {
    return (
        <section className="testimonial-section px-0">
            <Container fluid>
                <h1 className="title-text text-uppercase text-center text-white mb-3 mb-lg-5">
                    What people say about us
                </h1>

                <Swiper
                    modules={[Autoplay, Pagination]}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    loop={true}
                    speed={600}
                    spaceBetween={30}
                    slidesPerView={1} // 👈 default = 1 for mobile
                    breakpoints={{
                        640: { slidesPerView: 2 },  // tablets
                        1200: { slidesPerView: 3 }, // desktops
                    }}
                    className="testimonial-carousel"
                >
                    {testimonials.map((testimonial, index) => (
                        <SwiperSlide key={index}>
                            <div className="pt-50">
                                <div className="testimonial-img-div">
                                    <img
                                        className="mb-3 testimonial-img"
                                        loading="lazy"
                                        src={testimonial.imgSrc}
                                        alt={testimonial.name}
                                        height="100"
                                    />
                                </div>
                                <div className="bg-light p-4 pb-5 mx-3 rounded-4 card-height h-100">
                                    <div className="content-block">
                                        <h4 className="mb-2 mb-lg-3 fw-bold text-primary">
                                            {testimonial.name}
                                        </h4>
                                        <h6 className="mb-4 text-primary">{testimonial.text}</h6>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Container>
        </section>
    );
};

export default TestimonialCarousel;
